"use client";

import { usePathname } from "next/navigation";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { useEffect, useRef } from "react";

// Configure once at module level
NProgress.configure({
  showSpinner: false,
  speed: 400,
  minimum: 0.08,
  trickleSpeed: 200,
  easing: 'ease',
});

// Inject styles once - memoized at module level
let stylesInjected = false;

function injectStyles() {
  if (stylesInjected || typeof document === 'undefined') return;

  if (!document.getElementById("nprogress-custom-styles")) {
    const style = document.createElement("style");
    style.id = "nprogress-custom-styles";
    style.innerHTML = `
      #nprogress {
        pointer-events: none;
        z-index: 9999;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
      }

      #nprogress .bar {
        background: var(--color-primary) !important;
        opacity: 0.6;
        height: 2px !important;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 9999;
      }

      #nprogress .peg {
        display: block;
        position: absolute;
        right: 0px;
        width: 80px;
        height: 100%;
        box-shadow:
          0 0 6px var(--color-primary),
          0 0 3px var(--color-primary) !important;
        opacity: 0.7;
        transform: rotate(3deg) translate(0px, -4px);
      }

      /* Ensure visibility in both themes */
      .light-mode #nprogress .bar,
      .dark-mode #nprogress .bar {
        background: var(--color-primary) !important;
      }
    `;
    document.head.appendChild(style);
    stylesInjected = true;
  }
}

/**
 * Start NProgress - call this when navigation begins
 * Exported so useAppNavigation can trigger it
 */
export function startNavigationProgress() {
  NProgress.start();
}

/**
 * Complete NProgress - call this when navigation ends
 */
export function completeNavigationProgress() {
  NProgress.done();
}

export function NprogressProvider() {
  const pathname = usePathname();
  const pathnameRef = useRef(pathname);

  // Inject styles once on mount
  useEffect(() => {
    injectStyles();
  }, []);

  // Complete progress when pathname changes (navigation finished)
  useEffect(() => {
    // Only complete if pathname actually changed
    if (pathnameRef.current !== pathname) {
      pathnameRef.current = pathname;
      NProgress.done();
    }
  }, [pathname]);

  return null;
}
